import Modal from '../../../../../shared/Modal'
import Button from '../../../../../shared/Buttons/Button'
import AudioDropzone from '../../../../../shared/Dropzone/AudioDropzone'
import { useState } from 'react'
import { IAudio } from '../../../../../types/tasks.types'
import css from '../audioUpload.module.css'
import { ReactComponent as PlayIcon } from '../../../../../asserts/icons/play.svg'
import { ReactComponent as PauseIcon } from '../../../../../asserts/icons/pause.svg'

interface IProps {
  onClose: () => void
  onAudio: (audio: File) => void
  audio: IAudio | File
  fileName?: string
  onPlay: () => void
  onStop: () => void
  isPlaying: boolean
}

const UploadAudioModal = (props: IProps) => {
  const [file, setFile] = useState<File>(null)

  const renderAudioPlayControls = () => {
    if (!props.audio) return

    return !props.isPlaying ? (
      <PlayIcon onClick={props.onPlay} className={css.playPauseIcon} />
    ) : (
      <PauseIcon onClick={props.onStop} className={css.playPauseIcon} />
    )
  }

  const renderFileInfo = () => {
    if (!props.fileName) return null

    return (
      <div className={css.playPauseBlock} style={{ marginBottom: '1em' }}>
        {renderAudioPlayControls()}
        <span style={{ fontSize: '32px' }}>{props.fileName}</span>
      </div>
    )
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="flex-form">
        {renderFileInfo()}
        <AudioDropzone onFile={setFile} hasFile={Boolean(props.audio)} />
        <div className="form-footer">
          {file && <Button onClick={() => props.onAudio(file)}>Сохранить</Button>}
          {props.audio && !file && <Button onClick={() => props.onAudio(undefined)}>Удалить</Button>}
        </div>
      </div>
    </Modal>
  )
}

export default UploadAudioModal
